const COLOR = {
  BLACK: '#000000',

  WHITE: '#FFFFFF',

  BLUE: '#007DF1',
  BLUE_OLD_VERSION: '#0486ff',
  BLUE_1: '#E6F7FF',
  BLUE_5: '#4096ff',
  LIGHT_BLUE: '#13AB6C',
  DARK_BLUE: '#3E4977',
  DARK_BLUE_40: '#949BBC',
  GREEN: '#1D813',

  GRAY_06: '#B3BAC5',
  GRAY_1: '#FFFFFF',
  GRAY_2: '#F7F8FB',
  GRAY_4: '#E2E6ED',
  GRAY_5: '#D8DDE6',
  GRAY_6: '#AEB8CC',
  GRAY_7: '#99A6BF',
  GRAY_8: '#7A8AAC',
  GRAY_9: '#3D4961',
  GRAY_10: '#3E4977',
  GRAY_11: '#343B48',
  GREY_7: '#6B798E',
  GREY_8: '#5B687D',
  GREY_10: '#f7f8fb',
  GREY_12: '#272C36',
  GREY_20: '#F2F4F8',
  GREY_80: '#CBD1E0',
  GRAY_12: '#818C9E',
  COOL_GRAY: '#6B798E',
  LIGHT_COOL_GREY_6: '#818C9E',

  GREEN: '#52C41A',

  RED: '#d0021b',
  RED_2: '#B73232',
  RED_06: '#F5222D',
  RED_07: '#CF1322',
  ERROR_RED: '#E53E3E',
  RED_08: '#FC8181',

  DAHILA_YELLOW: '#CC7000',
  PRIMARY_YELLOW: '#FF8B00',

  HIGH_EMPHASIS: '#4E596B',

  PRIMARY_GREEN: '#00C356',
  MOSS_GREEN: '#24A148',
};

export default COLOR;
